module.exports = __webpack_public_path__ + "static/media/YourLogov2.17b60a31.svg";